import { ViewFactory } from 'wdc-cube-react'

import { HeaderScope, ConfigurationTabsScope } from '../scopes'
import HeaderView from './config-header'
import ConfigurationsView from './config_view'

export function registerViews(rv = ViewFactory.register) {
    rv(ConfigurationTabsScope, ConfigurationsView)
    rv(HeaderScope, HeaderView)
}
